import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import ChangePasswordModal from '../Auth/ChangePasswordModal';
import './Header.css';

interface HeaderProps {
  title?: string;
}

const Header: React.FC<HeaderProps> = ({ title = 'Wisdom Rehabilitation Centre LLC' }) => {
  const { user, logout } = useAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);

  const handleLogout = async () => {
    await logout();
    window.location.href = '/login';
  };

  return (
    <header className="header">
      <div className="header-content">
        <h1 className="header-title">{title}</h1>
        
        {user && (
          <div className="header-user">
            <div 
              className="user-info"
              onClick={() => setShowUserMenu(!showUserMenu)}
            >
              <span className="user-name">
                {user.first_name} {user.last_name}
                {user.is_superadmin && <span className="superadmin-badge">Super Admin</span>}
              </span>
              {!user.is_superadmin && <span className="user-role">({user.role_name})</span>}
              <span className="dropdown-arrow">▼</span>
            </div>
            
            {showUserMenu && (
              <div className="user-menu">
                <button 
                  className="menu-item"
                  onClick={() => {
                    setShowChangePassword(true);
                    setShowUserMenu(false);
                  }}
                >
                  Change Password
                </button>
                <button 
                  className="menu-item logout"
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        )}
      </div>
      
      {showChangePassword && (
        <ChangePasswordModal
          isOpen={showChangePassword}
          onClose={() => setShowChangePassword(false)}
          onSuccess={() => {
            setShowChangePassword(false);
            alert('Password changed successfully!');
          }}
        />
      )}
    </header>
  );
};

export default Header;